import {getAppLang, getUserToken} from "../../utils";
import axios from "axios";
import {BED_TYPE_LIST} from "../../constants/api.constants";

export function allBedTypes() {

    const requestOptions = {
        headers: { 'Content-Type': 'application/json', 'authToken': getUserToken(), 'language' : getAppLang()},
        body: {
            params: {
                "locale": getAppLang()
            }
        }
    };

    return dispatch => {
        dispatch({
            type: 'BED_TYPE',
            payload: axios.post(BED_TYPE_LIST, requestOptions.body, {headers: requestOptions.headers})
                .then(response => response.data.data)
        })
    }
}